export default `/* Ids Tree Node Component */
@keyframes keyframes-rotate-forward {
  0% {
    transform: rotate(-90deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes keyframes-rotate-backward {
  0% {
    transform: rotate(45deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
.ids-tree-node {
  display: block;
  list-style-type: none;
  margin-bottom: var(--ids-space-4xs);
  user-select: none;
}
.ids-tree-node .node-container {
  border: 1px solid transparent;
  position: relative;
  cursor: pointer;
  display: inline-flex;
  padding: 3px 8px;
  gap: 10px;
  box-sizing: border-box;
  align-items: center;
  min-height: 28px;
  color: var(--ids-tree-node-color-text-default);
  border-radius: var(--ids-border-radius-2xs);
  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), opacity var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-tree-node .node-container .icon,
.ids-tree-node .node-container .toggle-icon {
  padding-block: var(--ids-space-4xs);
  flex: 0 0 auto;
  transition: fill var(--ids-motion-duration) var(--ids-motion-ease);
  place-self: center;
}
.ids-tree-node .node-container .toggle-icon.rotate-forward {
  animation-duration: 0.2s;
  animation-iteration-count: 1;
  animation-name: keyframes-rotate-forward;
}
.ids-tree-node .node-container .toggle-icon.rotate-backward {
  animation-duration: 0.2s;
  animation-iteration-count: 1;
  animation-name: keyframes-rotate-backward;
}
.ids-tree-node .node-container .text {
  flex-grow: 1;
  min-height: 20px;
  place-self: center;
  transition: border var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-tree-node .node-container:hover, .ids-tree-node .node-container:active {
  color: var(--ids-tree-node-color-text-hover);
}
.ids-tree-node .node-container:hover .text, .ids-tree-node .node-container:active .text {
  border-color: var(--ids-tree-node-color-border-hover);
}
.ids-tree-node .node-container:focus {
  border-color: var(--ids-tree-node-color-border-focus);
  box-shadow: var(--ids-tree-node-shadow-focus);
  outline: none;
}
.ids-tree-node .node-container.is-dragging {
  background-color: var(--ids-tree-node-color-background-selected);
  border: 1px solid var(--ids-tree-node-color-background-selected);
  box-shadow: none;
  color: var(--ids-tree-node-color-text-hover);
  opacity: 0.5;
}
.ids-tree-node .node-container.drag-over-above::before {
  content: "";
  position: absolute;
  top: -2px;
  left: 0;
  right: 0;
  height: 1px;
  z-index: 10;
  width: 75%;
  background: linear-gradient(to right, var(--ids-tree-node-color-text-hover) 0.5px, transparent);
}
.ids-tree-node .node-container.drag-over-below::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 1px;
  width: 75%;
  z-index: 10;
  background: linear-gradient(to right, var(--ids-tree-node-color-text-hover) 0.5px, transparent);
}
.ids-tree-node .node-container.drag-over-node {
  background-color: var(--ids-color-blue-10);
  border: 1px dashed var(--ids-data-grid-filter-input-color-border-focus);
}
.ids-tree-node .group-nodes {
  display: block;
  overflow: hidden;
  padding-inline-start: 24px;
  transition: max-height 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
}
.ids-tree-node:not(.expanded) .group-nodes {
  max-height: 0;
  display: none;
}
.ids-tree-node[selected] .node-container {
  background-color: var(--ids-tree-node-color-background-selected);
  color: var(--ids-tree-node-color-text-selected);
}
.ids-tree-node[disabled] .node-container {
  color: var(--ids-tree-node-color-text-disabled);
  cursor: default;
  pointer-events: none;
  user-select: none;
}
.ids-tree-node[disabled] .node-container:hover, .ids-tree-node[disabled] .node-container:active {
  color: var(--ids-tree-node-color-text-disabled);
}
.ids-tree-node[disabled] .node-container:focus {
  border-color: var(--ids-color-transparent);
  box-shadow: none;
}

:host(:not([aria-level="1"])[aria-posinset="1"]) .node-container {
  margin-top: 2px;
}

::slotted(ids-badge) {
  height: 24px;
}

ids-checkbox::part(root) {
  margin: 0;
  min-height: 20px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdHJlZSIsInNvdXJjZXMiOlsiaWRzLXRyZWUtbm9kZS5zY3NzIiwiaWRzLXRyZWUtc2hhcmVkLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUNDQTtFQUNFO0lBQ0U7O0VBR0Y7SUFDRTs7O0FBSUo7RUFDRTtJQUNFOztFQUdGO0lBQ0U7OztBRGRKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7QUFBQTtFQUVFO0VBQ0E7RUFDQTtFQUNBOztBQUlBO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFFRTs7QUFFQTtFQUNFOztBQUlKO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7O0FBSUE7RUFDRTtFQUNBOztBQUtGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFFRTs7QUFHRjtFQUNFO0VBQ0E7OztBQU1SO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi8qIElkcyBUcmVlIE5vZGUgQ29tcG9uZW50ICovXG5AdXNlICcuL2lkcy10cmVlLXNoYXJlZCcgYXMgKjtcblxuLmlkcy10cmVlLW5vZGUge1xuICBkaXNwbGF5OiBibG9jaztcbiAgbGlzdC1zdHlsZS10eXBlOiBub25lO1xuICBtYXJnaW4tYm90dG9tOiB2YXIoLS1pZHMtc3BhY2UtNHhzKTtcbiAgdXNlci1zZWxlY3Q6IG5vbmU7XG5cbiAgLm5vZGUtY29udGFpbmVyIHtcbiAgICBib3JkZXI6IDFweCBzb2xpZCB0cmFuc3BhcmVudDtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICAgIGRpc3BsYXk6IGlubGluZS1mbGV4O1xuICAgIHBhZGRpbmc6IDNweCA4cHg7XG4gICAgZ2FwOiAxMHB4O1xuICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBtaW4taGVpZ2h0OiAyOHB4O1xuICAgIGNvbG9yOiB2YXIoLS1pZHMtdHJlZS1ub2RlLWNvbG9yLXRleHQtZGVmYXVsdCk7XG4gICAgYm9yZGVyLXJhZGl1czogdmFyKC0taWRzLWJvcmRlci1yYWRpdXMtMnhzKTtcbiAgICB0cmFuc2l0aW9uOiBiYWNrZ3JvdW5kLWNvbG9yIHZhcigtLWlkcy1tb3Rpb24tZHVyYXRpb24pIHZhcigtLWlkcy1tb3Rpb24tZWFzZSksIG9wYWNpdHkgdmFyKC0taWRzLW1vdGlvbi1kdXJhdGlvbikgdmFyKC0taWRzLW1vdGlvbi1lYXNlKTtcblxuICAgIC5pY29uLFxuICAgIC50b2dnbGUtaWNvbiB7XG4gICAgICBwYWRkaW5nLWJsb2NrOiB2YXIoLS1pZHMtc3BhY2UtNHhzKTtcbiAgICAgIGZsZXg6IDAgMCBhdXRvO1xuICAgICAgdHJhbnNpdGlvbjogZmlsbCB2YXIoLS1pZHMtbW90aW9uLWR1cmF0aW9uKSB2YXIoLS1pZHMtbW90aW9uLWVhc2UpO1xuICAgICAgcGxhY2Utc2VsZjogY2VudGVyO1xuICAgIH1cblxuICAgIC50b2dnbGUtaWNvbiB7XG4gICAgICAmLnJvdGF0ZS1mb3J3YXJkIHtcbiAgICAgICAgYW5pbWF0aW9uLWR1cmF0aW9uOiAwLjJzO1xuICAgICAgICBhbmltYXRpb24taXRlcmF0aW9uLWNvdW50OiAxO1xuICAgICAgICBhbmltYXRpb24tbmFtZToga2V5ZnJhbWVzLXJvdGF0ZS1mb3J3YXJkO1xuICAgICAgfVxuXG4gICAgICAmLnJvdGF0ZS1iYWNrd2FyZCB7XG4gICAgICAgIGFuaW1hdGlvbi1kdXJhdGlvbjogMC4ycztcbiAgICAgICAgYW5pbWF0aW9uLWl0ZXJhdGlvbi1jb3VudDogMTtcbiAgICAgICAgYW5pbWF0aW9uLW5hbWU6IGtleWZyYW1lcy1yb3RhdGUtYmFja3dhcmQ7XG4gICAgICB9XG4gICAgfVxuXG4gICAgLnRleHQge1xuICAgICAgZmxleC1ncm93OiAxO1xuICAgICAgbWluLWhlaWdodDogMjBweDtcbiAgICAgIHBsYWNlLXNlbGY6IGNlbnRlcjtcbiAgICAgIHRyYW5zaXRpb246IGJvcmRlciB2YXIoLS1pZHMtbW90aW9uLWR1cmF0aW9uKSB2YXIoLS1pZHMtbW90aW9uLWVhc2UpLCBjb2xvciB2YXIoLS1pZHMtbW90aW9uLWR1cmF0aW9uKSB2YXIoLS1pZHMtbW90aW9uLWVhc2UpO1xuICAgIH1cblxuICAgICY6aG92ZXIsXG4gICAgJjphY3RpdmUge1xuICAgICAgY29sb3I6IHZhcigtLWlkcy10cmVlLW5vZGUtY29sb3ItdGV4dC1ob3Zlcik7XG5cbiAgICAgIC50ZXh0IHtcbiAgICAgICAgYm9yZGVyLWNvbG9yOiB2YXIoLS1pZHMtdHJlZS1ub2RlLWNvbG9yLWJvcmRlci1ob3Zlcik7XG4gICAgICB9XG4gICAgfVxuXG4gICAgJjpmb2N1cyB7XG4gICAgICBib3JkZXItY29sb3I6IHZhcigtLWlkcy10cmVlLW5vZGUtY29sb3ItYm9yZGVyLWZvY3VzKTtcbiAgICAgIGJveC1zaGFkb3c6IHZhcigtLWlkcy10cmVlLW5vZGUtc2hhZG93LWZvY3VzKTtcbiAgICAgIG91dGxpbmU6IG5vbmU7XG4gICAgfVxuXG4gICAgJi5pcy1kcmFnZ2luZyB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1pZHMtdHJlZS1ub2RlLWNvbG9yLWJhY2tncm91bmQtc2VsZWN0ZWQpO1xuICAgICAgYm9yZGVyOiAxcHggc29saWQgdmFyKC0taWRzLXRyZWUtbm9kZS1jb2xvci1iYWNrZ3JvdW5kLXNlbGVjdGVkKTtcbiAgICAgIGJveC1zaGFkb3c6IG5vbmU7XG4gICAgICBjb2xvcjogdmFyKC0taWRzLXRyZWUtbm9kZS1jb2xvci10ZXh0LWhvdmVyKTtcbiAgICAgIG9wYWNpdHk6IDAuNTtcbiAgICB9XG5cbiAgICAmLmRyYWctb3Zlci1hYm92ZTo6YmVmb3JlIHtcbiAgICAgIGNvbnRlbnQ6ICcnO1xuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgdG9wOiAtMnB4O1xuICAgICAgbGVmdDogMDtcbiAgICAgIHJpZ2h0OiAwO1xuICAgICAgaGVpZ2h0OiAxcHg7XG4gICAgICB6LWluZGV4OiAxMDtcbiAgICAgIHdpZHRoOiA3NSU7XG4gICAgICBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQodG8gcmlnaHQsIHZhcigtLWlkcy10cmVlLW5vZGUtY29sb3ItdGV4dC1ob3ZlcikgMC41cHgsIHRyYW5zcGFyZW50KTtcbiAgICB9XG5cbiAgICAmLmRyYWctb3Zlci1iZWxvdzo6YWZ0ZXIge1xuICAgICAgY29udGVudDogJyc7XG4gICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICBib3R0b206IC0ycHg7XG4gICAgICBsZWZ0OiAwO1xuICAgICAgcmlnaHQ6IDA7XG4gICAgICBoZWlnaHQ6IDFweDtcbiAgICAgIHdpZHRoOiA3NSU7XG4gICAgICB6LWluZGV4OiAxMDtcbiAgICAgIGJhY2tncm91bmQ6IGxpbmVhci1ncmFkaWVudCh0byByaWdodCwgdmFyKC0taWRzLXRyZWUtbm9kZS1jb2xvci10ZXh0LWhvdmVyKSAwLjVweCwgdHJhbnNwYXJlbnQpO1xuICAgIH1cblxuICAgICYuZHJhZy1vdmVyLW5vZGUge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0taWRzLWNvbG9yLWJsdWUtMTApO1xuICAgICAgYm9yZGVyOiAxcHggZGFzaGVkIHZhcigtLWlkcy1kYXRhLWdyaWQtZmlsdGVyLWlucHV0LWNvbG9yLWJvcmRlci1mb2N1cyk7XG4gICAgfVxuICB9XG5cbiAgLmdyb3VwLW5vZGVzIHtcbiAgICBkaXNwbGF5OiBibG9jaztcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgIHBhZGRpbmctaW5saW5lLXN0YXJ0OiAyNHB4O1xuICAgIHRyYW5zaXRpb246IG1heC1oZWlnaHQgMzAwbXMgY3ViaWMtYmV6aWVyKDAuMTcsIDAuMDQsIDAuMDMsIDAuOTQpO1xuICB9XG5cbiAgJjpub3QoLmV4cGFuZGVkKSAuZ3JvdXAtbm9kZXMge1xuICAgIG1heC1oZWlnaHQ6IDA7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxuXG4gICZbc2VsZWN0ZWRdIHtcbiAgICAubm9kZS1jb250YWluZXIge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0taWRzLXRyZWUtbm9kZS1jb2xvci1iYWNrZ3JvdW5kLXNlbGVjdGVkKTtcbiAgICAgIGNvbG9yOiB2YXIoLS1pZHMtdHJlZS1ub2RlLWNvbG9yLXRleHQtc2VsZWN0ZWQpO1xuICAgIH1cbiAgfVxuXG4gICZbZGlzYWJsZWRdIHtcbiAgICAubm9kZS1jb250YWluZXIge1xuICAgICAgY29sb3I6IHZhcigtLWlkcy10cmVlLW5vZGUtY29sb3ItdGV4dC1kaXNhYmxlZCk7XG4gICAgICBjdXJzb3I6IGRlZmF1bHQ7XG4gICAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgICAgIHVzZXItc2VsZWN0OiBub25lO1xuXG4gICAgICAmOmhvdmVyLFxuICAgICAgJjphY3RpdmUge1xuICAgICAgICBjb2xvcjogdmFyKC0taWRzLXRyZWUtbm9kZS1jb2xvci10ZXh0LWRpc2FibGVkKTtcbiAgICAgIH1cblxuICAgICAgJjpmb2N1cyB7XG4gICAgICAgIGJvcmRlci1jb2xvcjogdmFyKC0taWRzLWNvbG9yLXRyYW5zcGFyZW50KTtcbiAgICAgICAgYm94LXNoYWRvdzogbm9uZTtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuOmhvc3QoOm5vdChbYXJpYS1sZXZlbD1cIjFcIl0pW2FyaWEtcG9zaW5zZXQ9XCIxXCJdKSAubm9kZS1jb250YWluZXIge1xuICBtYXJnaW4tdG9wOiAycHg7XG59XG5cbjo6c2xvdHRlZChpZHMtYmFkZ2UpIHtcbiAgaGVpZ2h0OiAyNHB4O1xufVxuXG5pZHMtY2hlY2tib3g6OnBhcnQocm9vdCkge1xuICBtYXJnaW46IDA7XG4gIG1pbi1oZWlnaHQ6IDIwcHg7XG59XG4iLCIvLyBLZXlmcmFtZXMgZm9yIHRoZSBcInBsdXNtaW51c1wiIGljb24gYW5pbWF0aW9uXG5Aa2V5ZnJhbWVzIGtleWZyYW1lcy1yb3RhdGUtZm9yd2FyZCB7XG4gIDAlIHtcbiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgtOTBkZWcpO1xuICB9XG5cbiAgMTAwJSB7XG4gICAgdHJhbnNmb3JtOiByb3RhdGUoMGRlZyk7XG4gIH1cbn1cblxuQGtleWZyYW1lcyBrZXlmcmFtZXMtcm90YXRlLWJhY2t3YXJkIHtcbiAgMCUge1xuICAgIHRyYW5zZm9ybTogcm90YXRlKDQ1ZGVnKTtcbiAgfVxuXG4gIDEwMCUge1xuICAgIHRyYW5zZm9ybTogcm90YXRlKDBkZWcpO1xuICB9XG59XG5cbi8vIEFkanVzdCBiYWRnZSBydWxlcyBmb3IgdHJlZSBub2RlXG5AbWl4aW4gdHJlZS1ub2RlLWJhZGdlKCkge1xuICBpZHMtYmFkZ2U6OnBhcnQoYmFkZ2UpIHtcbiAgICBib3JkZXItd2lkdGg6IHZhcigtLWlkcy1ib3JkZXItd2lkdGgtbm9uZSk7XG4gICAgbWFyZ2luOiAwO1xuICAgIG1hcmdpbi1pbmxpbmUtZW5kOiA4cHg7XG4gIH1cblxuICA6OnNsb3R0ZWQoaWRzLWJhZGdlKSB7XG4gICAgYWxpZ24tc2VsZjogY2VudGVyO1xuICB9XG59XG4iXX0= */`;
